// Copyright (c) StrangeBee 2024

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { WidgetRadarOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { RadarForm, RadarValues } from '@Organisms/Dashboard/WidgetManage/Radar/RadarForm';
import { getNewRadarWidget } from './NewRadarDrawer';

interface RadarDrawerProps {
    data: WidgetRadarOutput;
}

const RadarDrawer = ({ data }: RadarDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (Radar: RadarValues): void => {
        const widgetId = data.id;
        const widgetRadar: WidgetRadarOutput = {
            ...getNewRadarWidget(Radar),
            id: widgetId,
        };

        editWidget(widgetRadar, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="radar">
            {(toggleDrawer, { setFieldsTouched }) => (
                <RadarForm
                    onCancel={() => {
                        form.resetFields();
                        setFieldsTouched(false);
                        toggleDrawer();
                    }}
                    onChange={() => setFieldsTouched(true)}
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default RadarDrawer;
